export default __webpack_public_path__ + "static/media/lebron.289fab26.png";